module.exports = __webpack_public_path__ + "static/media/UTR.82c36178.svg";